import React from "react";
import { useNavigate } from "react-router";
import { ArrowBack, Schedule } from "@material-ui/icons";
import HeaderDescription from "../../../components/commons/HeaderDescription";
import MOButtonV2 from "../../../components/commons/MOButtonV2";

const VendorComingSoon = ({ vendor }) => {
  const navigate = useNavigate();

  return (
    <div className="rate-analysis-page">
      <button
        type="button"
        className="rate-analysis-back-btn"
        onClick={() => navigate("/dashboard/rate-analysis")}
      >
        <ArrowBack className="rate-analysis-back-icon" />
        Back to platform selection
      </button>

      <HeaderDescription
        heading={`Rate Analysis — ${vendor.value}`}
        description="This platform is not available for rate analysis yet."
      />

      <div className="bg-white main-section-spacing border-radius-8 rate-analysis-coming-soon">
        <div className="rate-analysis-coming-soon-icon-wrap">
          <Schedule className="rate-analysis-coming-soon-icon" />
        </div>

        <div className="rate-analysis-vendor-badge rate-analysis-coming-soon-badge">
          <img src={vendor.circleIcon} alt={vendor.value} />
          <img
            src={vendor.mainImage}
            alt={vendor.value}
            className="rate-analysis-vendor-badge-logo"
          />
        </div>

        <h2 className="rate-analysis-coming-soon-title">Coming Soon</h2>
        <p className="rate-analysis-coming-soon-message">
          {vendor.comingSoonMessage ||
            `${vendor.value} rate analysis will be available soon.`}
        </p>
        <p className="rate-analysis-coming-soon-hint">
          Form, API integration, and results for this platform are still in
          development.
        </p>

        <MOButtonV2
          text="Choose another platform"
          onClick={() => navigate("/dashboard/rate-analysis")}
          backgroundColor="#29AEE6"
          textColor="#FFFFFF"
          border="none"
          radius={4}
          height={38}
          fontSize={13}
          padding="8px 20px"
        />
      </div>
    </div>
  );
};

export default VendorComingSoon;
